export enum VIEW_TYPE {
  SINGLE_FIELD = "SINGLE_FIELD",
  ALL_FIELDS = "ALL_FIELDS",
  SIMULATION = "SIMULATION",
}

export enum IMPACT_PANEL_CALCULATION_TYPE {
  TOTAL = "TOTAL",
  PER_HA = "PER_HA",
}

export enum IMPACT_PANEL_RESULT_TYPE {
  YEARLY = "YEARLY",
  ALL_YEARS = "ALL_YEARS",
}
